import { IBulkCard } from '@/features/cards/store/models/bulk-card.model';
import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';

export enum BulkCardCreationsActionTypes {
  GET_BULK_CARD_CREATIONS = 'BULK_CARD.GET_BULK_CARD_CREATION',
  GET_BULK_CARD_CREATIONS_SUCCESS = 'BULK_CARD.GET_BULK_CARD_CREATION_SUCCESS',
  GET_BULK_CARD_CREATIONS_FAIL = 'BULK_CARD.GET_BULK_CARD_CREATION_FAIL',

  SET_STEP = 'BULK_CARD.SET_STEP',

  CREATE_BULK_CARD = 'BULK_CARD.CREATE_BULK_CARD',
  CREATE_BULK_CARD_FAIL = 'BULK_CARD.CREATE_BULK_CARD_FAIL',
  CREATE_BULK_CARD_SUCCESS = 'BULK_CARD.CREATE_BULK_CARD_SUCCESS',

  CLEAR_BULK_CARD_CREATION_CACHE = 'BULK_CARD.CLEAR_BULK_CARD_CREATION_CACHE',

  GET_BULK_CARD_CREATION_REPORT = 'BULK_CARD.GET_BULK_CARD_CREATION_REPORT',
  GET_BULK_CARD_CREATION_REPORT_FAIL = 'BULK_CARD.GET_BULK_CARD_CREATION_REPORT_FAIL',
  GET_BULK_CARD_CREATION_REPORT_SUCCESS = 'BULK_CARD.GET_BULK_CARD_CREATION_REPORT_SUCCESS',
}

export interface IGetBulkCardCreationsAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS;
}

export interface IGetBulkCardCreationsSuccessAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS_SUCCESS;
  bulkCardCreations: IBulkCard[];
}

export interface IGetBulkCardCreationsFailAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS_FAIL;
  error: TAppError;
}

export interface IBulkCardCreationStepperAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.SET_STEP;
  currentStep: number;
  bulkCardCreationDraft?: IBulkCard | null;
}
export interface IBulkCardCreationAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.CREATE_BULK_CARD;
}
export interface IBulkCardCreationFailAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.CREATE_BULK_CARD_FAIL;
  error: TAppError;
}
export interface IBulkCardCreationSuccessAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.CREATE_BULK_CARD_SUCCESS;
  bulkCard: IBulkCard;
}
export interface IClearBulkCardCreationStepperAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.CLEAR_BULK_CARD_CREATION_CACHE;
}

export interface IGetBulkCardCreationsReportAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT;
}
export interface IGetBulkCardCreationsReportSuccessAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT_FAIL;
  error: TAppError;
}
export interface IGetBulkCardCreationsReportFailAction extends IBaseAction {
  type: typeof BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT_SUCCESS;
  bulkCardCreationReport: string;
}

export type TBulkCardCreationsAction =
  | IGetBulkCardCreationsAction
  | IGetBulkCardCreationsSuccessAction
  | IGetBulkCardCreationsFailAction
  | IBulkCardCreationStepperAction
  | IBulkCardCreationAction
  | IBulkCardCreationFailAction
  | IBulkCardCreationSuccessAction
  | IClearBulkCardCreationStepperAction
  | IGetBulkCardCreationsReportAction
  | IGetBulkCardCreationsReportSuccessAction
  | IGetBulkCardCreationsReportFailAction;

export interface IBulkCardCreationsState extends IBaseState {
  bulkCardCreations: IBulkCard[] | [];
  currentStep: number;
  latestStep: number;
  bulkCardCreationDraft: IBulkCard | null;
}

export interface IBulkCardCreationReportState extends IBaseState {
  bulkCardCreationReport: string | null;
}
